import type { PostalAddress } from '@gpx-spa/geo-domain'

export interface GoogleAddressComponent {
  longText: string | null
  shortText: string | null
  types: string[]
}

export function postalAddressFromComponents(components: GoogleAddressComponent[]): PostalAddress {
  const long = (type: string) => components.find((c) => c.types.includes(type))?.longText ?? ''
  const short = (type: string) => components.find((c) => c.types.includes(type))?.shortText ?? ''

  return {
    line1: [long('street_number'), long('route')].filter(Boolean).join(' '),
    line2: long('subpremise'),
    city: long('locality') || long('postal_town') || long('sublocality') || long('neighborhood'),
    state: short('administrative_area_level_1'),
    zip: long('postal_code'),
    country: short('country'),
  }
}
